import { Component } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';
import { NgTableComponent } from '../tableModel/ng-table.component';
import { NgTableFilteringDirective } from '../tableModel/ng-table-filtering.directive';
import { NgTablePagingDirective } from '../tableModel/ng-table-paging.directive';
import { NgTableSortingDirective } from '../tableModel/ng-table-sorting.directive';
import { Log } from '../model/log.class';
import { ActivatedRoute, Router } from '@angular/router';
import { UserStatistic } from '../model/userStatistic.class';

@Component({
    selector: 'app-user-stat',
    templateUrl: './user.stat.component.html'
})
export class UserStatComponent {

    userStats: UserStatistic[];
    columns: Array<any> = [
        {
            title: 'Datum',
            name: 'date',
            sort: ''
        },
        {
            title: 'Gescheiterte Loginversuche',
            name: 'wrongLogins',
            sort: ''
        },
        {
            title: 'Erfolgreiche Loginversuche',
            name: 'correctLogins',
            sort: ''
        },
        {
            title: 'Anzahl Uploads',
            name: 'uploads',
            sort: ''
        }
    ];

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router) {
        this.route.params.subscribe(
            (params) => {
                userService.getStats(params['userId'], 'user').subscribe((userStats) => this.userStats = userStats as UserStatistic[]);
            });

    }
}



// WEBPACK FOOTER //
// ./src/app/userStat/user.stat.component.ts